import { Controller } from '@hotwired/stimulus'
import consumer from '~/channels/consumer'

export default class extends Controller {
  static targets = ['syncButton', 'progress']

  connect() {
    this.subscribeToSyncUpdates()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  subscribeToSyncUpdates() {
    this.subscription = consumer.subscriptions.create('UserSyncChannel', {
      connected: () => {
        console.log('Connected to UserSyncChannel')
      },

      disconnected: () => {
        console.log('Disconnected from UserSyncChannel')
      },

      received: (data) => {
        this.handleSyncUpdate(data)
      }
    })
  }

  handleSyncUpdate(data) {
    // Workers send: event, provider, success, error
    // connection_id may not be present - workers broadcast by provider
    const { event, error, provider } = data
    const connectionId = data.connection_id

    switch (event) {
      case 'sync_started':
        if (connectionId) this.showProgress(connectionId)
        break
      case 'sync_progress':
        if (connectionId) this.updateProgress(connectionId, data.message || 'Syncing...')
        break
      case 'sync_completed':
        // Hide progress for specific connection if ID provided
        if (connectionId) this.hideProgress(connectionId)
        // Also hide any provider-based progress elements
        this.hideProviderProgress(provider)
        this.showNotification(`${provider || 'Integration'} synced successfully`, 'success')
        // Reload the page to show updated sync times
        setTimeout(() => window.location.reload(), 1500)
        break
      case 'sync_failed':
        if (connectionId) this.hideProgress(connectionId)
        this.hideProviderProgress(provider)
        this.showNotification(error || 'Sync failed', 'error')
        break
      default:
        console.log('Unknown sync event:', event, data)
    }
  }

  hideProviderProgress(provider) {
    if (!provider) return

    // Find and reset any buttons/progress for this provider
    this.syncButtonTargets.forEach((button) => {
      if (button.dataset.provider === provider) {
        button.textContent = 'Sync'
        button.closest('button')?.removeAttribute('disabled')
      }
    })
  }

  sync(event) {
    const button = event.currentTarget
    const form = button.closest('form')

    // Find the connection ID from the form action URL
    const actionUrl = form.getAttribute('action')
    const match = actionUrl.match(/integrations\/([^/]+)\/sync/)
    const connectionId = match ? match[1] : null

    if (connectionId) {
      this.showProgress(connectionId)
    }

    // Let the form submit normally
  }

  showProgress(connectionId) {
    const progressEl = this.progressTargets.find((el) => el.dataset.id === connectionId)
    if (progressEl) {
      progressEl.classList.remove('hidden')
    }

    const button = this.syncButtonTargets.find((el) => el.dataset.id === connectionId)
    if (button) {
      button.textContent = 'Syncing...'
      button.closest('button')?.setAttribute('disabled', 'disabled')
    }
  }

  updateProgress(connectionId, message) {
    const progressEl = this.progressTargets.find((el) => el.dataset.id === connectionId)
    if (progressEl) {
      const messageEl = progressEl.querySelector('span')
      if (messageEl) {
        messageEl.textContent = message
      }
    }
  }

  hideProgress(connectionId) {
    const progressEl = this.progressTargets.find((el) => el.dataset.id === connectionId)
    if (progressEl) {
      progressEl.classList.add('hidden')
    }

    const button = this.syncButtonTargets.find((el) => el.dataset.id === connectionId)
    if (button) {
      button.textContent = 'Sync'
      button.closest('button')?.removeAttribute('disabled')
    }
  }

  showNotification(message, type) {
    // Create a temporary notification
    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 z-50 p-4 rounded border-2 ${
      type === 'success' ?
        'bg-green-50 border-green-500 text-green-700' :
        'bg-red-50 border-red-500 text-red-700'
    }`
    notification.textContent = message

    document.body.appendChild(notification)

    setTimeout(() => {
      notification.remove()
    }, 5000)
  }
}
